import { render } from "./PuppyIconComponent.vue?vue&type=template&id=86341a6c"
const script = {}

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__